import { Block, IconButton } from "@xprog/prensa";
import { CloseIcon } from "components/Assets/CloseIcon";
import ClickableAsset from "components/ClickableAsset/ClickableAsset.index";
import { SubscriberInfo } from "components/SideMenu/SubscriberInfo/SubscriberInfo.index";
import { AssetsContext } from "providers/Assets";
import { ServerSidePropsContext } from "providers/ServerSideProps";
import React, { useContext } from "react";
import { SideMenuSectionHeaderProps } from "./props";
import { SessionDataContext } from "providers/Session";


export const SideMenuSectionHeader: React.FC<SideMenuSectionHeaderProps> = ({
  config,
  onClose,
  onLogin,
  onLogout,
  variant,
}) => {
  const serverSideContext = useContext(ServerSidePropsContext);
  const variantConfig: any = config.variants[variant];
  const { advertiseSection } = config

  const logoName = variantConfig?.logo?.name || "";
  const assetsContext = useContext(AssetsContext);
  const banners = assetsContext?.assets?.banners;
  const banner = banners.find((i) => i.name === logoName);
  const sessionData = useContext(SessionDataContext);
  const isPaywall =
    serverSideContext?.site?.pageConfig?.featureRadioSelectPaywall;

    return (
    <Block>
      <Block css={variantConfig?.css?.container}>
        <Block css={variantConfig?.css?.iconContainer}>
          <IconButton
            icon={<CloseIcon />}
            color={variantConfig?.css?.iconColor}
            onClick={onClose}
            size="md"
            variant="ghost"
            css={variantConfig?.css?.icon}
          />
        </Block>
        {banner && (
          <ClickableAsset
            alt={banner.name}
            src={banner.url}
            href={variantConfig?.logo?.href}
            id={variantConfig.logo?.id}
            height={banner.height}
            width={banner.width}
            css={{ container: variantConfig?.css.logo }}
            target='blank'
          />
        )}
      </Block>
{/*       {isPaywall !== "DESATIVADO" && (
        <SubscriberInfo
          amountLeft={
            sessionData?.inscricaoDegustador?.creditosDegustadorList[0]
              ?.quantidade
          }
          type={sessionData?.id ? "ASSINANTE" : variant}
          onLogin={onLogin}
          onLogout={onLogout}
          username={sessionData?.emailUsuario?.split("@")[0] || ""}
        />
      )} */}
    </Block>
  );
};
